var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Loading } from 'element-ui';
import GlobalVue from '../../globalVue';
import ApplicationOrderService from '../../api/ApplicationOrderService';
import Header from './components/Header.vue';
import Add from './Add.vue';
import Detail from './Detail.vue';
var ApplicationOrder = (function (_super) {
    __extends(ApplicationOrder, _super);
    function ApplicationOrder() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.listData = [];
        _this.total = 0;
        _this.selectRows = [];
        _this.tableHeight = document.documentElement.clientHeight - 240;
        return _this;
    }
    ApplicationOrder.prototype.created = function () {
        this.service = ApplicationOrderService.getInstance();
    };
    ApplicationOrder.prototype.toPage = function (order_id, type) {
        var pageTitleObj = {
            detail: '查看费用',
            edit: '修改费用',
            add: '添加费用',
        };
        this.addTab({
            component: type === 'detail' ? Detail : Add,
            title: pageTitleObj[type],
            showExist: true,
            name: 'application_order_' + type + order_id,
            cprops: {
                order_id: order_id,
            },
        });
        window._czc.push(['_trackEvent', '费用管理', pageTitleObj[type]]);
    };
    ApplicationOrder.prototype.audit = function () {
        this.operationConfirm('audit');
    };
    ApplicationOrder.prototype.discard = function () {
        this.operationConfirm('discard');
    };
    ApplicationOrder.prototype.operationConfirm = function (type) {
        var _this = this;
        if (!this.checkSelectIds())
            return;
        var confirmTips = {
            audit: {
                operationText: '费用管理审核',
                tipCotent: '审核后，费用单据不可修改且会记录到经营报表中，确定审核吗？',
            },
            discard: {
                operationText: '费用管理废弃',
                tipCotent: '废弃后，费用单据不可恢复，确定废弃吗？',
            },
        };
        this.$confirm(confirmTips[type] && confirmTips[type].tipCotent).then(function () {
            var loadingInstance = Loading.service({ fullscreen: true });
            var order_ids = _this.getSelectIds();
            _this.service[type]({
                order_ids: order_ids,
            })
                .then(function (res) {
                loadingInstance.close();
                if (res.data.code == 76) {
                    _this.$message.error(res.data.msg);
                }
                else {
                    _this.$message.success(res.data.msg || '操作成功');
                    window._czc.push([
                        '_trackEvent',
                        '费用管理',
                        confirmTips[type] && confirmTips[type].operationText,
                    ]);
                    _this.$refs.pagination.clear();
                }
                _this.getList();
            })
                .catch(function (err) {
                loadingInstance.close();
                _this.$message.error(err.msg || err.message);
            });
        }, function (err) { });
    };
    ApplicationOrder.prototype.addTab = function (options) {
        options.opener = this;
        GlobalVue.$emit('addTab', options);
    };
    ApplicationOrder.prototype.getSelectIds = function () {
        var orderIds = this.selectRows.map(function (item) { return item.order_id; });
        return orderIds.join(',');
    };
    ApplicationOrder.prototype.checkSelectIds = function () {
        if (!this.selectRows || !this.selectRows.length) {
            this.$message.error('请先选择类别');
            return false;
        }
        else {
            return true;
        }
    };
    ApplicationOrder.prototype.selectionChange = function (rows) {
        this.selectRows = rows;
    };
    ApplicationOrder.prototype.search = function (filter) {
        this.$refs.pagination && this.$refs.pagination.clear();
        filter.order_status = filter.order_status.join(',');
        this.filter = filter;
        this.getList();
    };
    ApplicationOrder.prototype.getList = function () {
        var _this = this;
        var pager = this.$refs.pagination.getPage();
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service
            .getList(Object.assign({}, this.filter, pager))
            .then(function (res) {
            loadingInstance.close();
            var DATA = res.data || { data: [], total: 0 };
            _this.listData = Array.isArray(DATA.data) ? DATA.data : [];
            _this.total = DATA.total;
        })
            .catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message);
        });
    };
    ApplicationOrder.prototype.pageChange = function () {
        this.getList();
    };
    ApplicationOrder = __decorate([
        Component({
            components: {
                'list-header': Header,
            },
        })
    ], ApplicationOrder);
    return ApplicationOrder;
}(Vue));
export default ApplicationOrder;
